<template>
	<div class="cadastrar" v-if="add">
		<i class="fas fa-folder-plus"></i>
		<span class="titulo"> Cadastrar coleção</span>
		<div class="nome"><input type="text" v-model="dados.nome" placeholder="Nome:"></div>
		<div class="desc"><textarea name="comment" v-model="dados.descricao" placeholder="Descricao:"></textarea></div>
		<div class="btns">
			<div class="button descartar" @click="descartar">CANCELAR</div>
			<div class="button criar" @click="cadastrar">CADASTRAR</div>
		</div>
	</div>
	<div class="renomear" v-else>
		<i class="fas fa-folder-plus"></i>
		<span class="titulo"> Renomear coleção</span>
		<div class="nome"><input type="text" v-model="dados.nome" placeholder="Nome:"></div>
		<div class="desc"><textarea name="comment" v-model="dados.descricao" placeholder="Descricao:"></textarea></div>
		<div class="btns">
			<div class="button descartar" @click="descartar">CANCELAR</div>
			<div class="button criar" @click="rename">SALVAR</div>
		</div>
	</div>
</template>

<script>
import { colecoes } from '@/services/colecoes'
export default {
	name: 'RenomearColecao',
	props: {
		boxEdit: {
			type: Boolean, default: false
		},
		id: {
			type: String
		},
		idColecao: {
			type: String
		},
		nome: {
			type: String
		},
		descricao: {
			type: String
		},
		add: {
			type: Boolean, default: true
		}
	},
	data () {
		return {
			dados: {
				nome: '',
				comentario: '',
				descricao: '',
				usuarioId: this.$auth.user().id,
				colecaoId: ''
			},
			msg: ''
		}
	},
	methods: {
		descartar () {
			this.$emit('boxDescartar', this.boxEdit)
		},
		async rename () {
			this.dados.colecaoId = this.idColecao
			const colecao = await colecoes.update(this.id, this.dados)

			if (colecao.status === 200) {
				this.$emit('boxDescartar', this.boxEdit)
				this.msg = 'Alteração realizada com Sucesso !'
				this.$emit('boxMessage', this.msg, 'success')
			} else {
				this.msg = `Erro ao Alterar ! - Error: ${colecao.status}`
				this.$emit('boxMessage', this.msg, 'error')
				this.$emit('boxDescartar', this.boxEdit)
			}
		},
		async cadastrar () {
			this.dados.colecaoId = this.idColecao
			const colecao = await colecoes.create(this.dados)

			if (colecao.status === 200) {
				this.$emit('boxDescartar', this.boxEdit)
				this.msg = 'Cadastrado com Sucesso !'
				this.$emit('boxMessage', this.msg, 'success')
			} else {
				this.msg = `Erro ao Cadastrar ! - Error: ${colecao.status}`
				this.$emit('boxMessage', this.msg, 'error')
				this.$emit('boxDescartar', this.boxEdit)
			}
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			this.dados.nome = this.nome
			this.dados.descricao = this.descricao
		})
	}
}
</script>

<style lang="scss" scoped>
	.cadastrar, .renomear {
		background-color: #FEFEFE;
		display:flex;
		flex-direction: column;
		padding:10px;
		border-radius:5px;
		width: 584px;
		position:fixed;
		left: 50%;
		top: 30%;
		margin-left: -292px;

		i {
			color:#052354;
			font-size: 43px;
			margin-bottom: 18px;
		}

		.titulo {
			color:#052354;
			font-weight: 700;
			font-size: 20px;
			margin-bottom: 11px;
		}

		.nome {
			color:#EBECEF;
			border: 1px solid;
			border-radius: 5px;
			height: 40px;

			input {
				background-color: #F8F9FB;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font: Condensed 16px Roboto;
			}
		}
		.desc {
			color:#EBECEF;
			margin-top:10px;
			border: 1px solid;
			border-radius: 5px;
			height: 100px;
			margin-bottom: 15px;

			textarea {
				background-color: #F8F9FB;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				resize: none;
				font: Condensed 16px Roboto;
			}
		}

		.btns {
			display:flex;
			justify-items: end;

			.button {
				padding: 12px 20px;
				width: 136px;
				display: flex;
				justify-content: center;
				font-weight: 700;
				margin-right: 10px;
				transition: .333s all;

				&.descartar {
					background-color:#FFFFFF;
					border-radius:5px;
					border: 1px solid;
					border-color: #06162B;
					color:#06162B;
					cursor: pointer;

					&:hover {
						background-color: #E64141;
						color: #FFF;
						border-color: transparent;
					}
				}

				&.criar {
					background-color: #00659D;
					border-radius:5px;
					border: 1px solid;
					color:#FFFFFF;
					cursor: pointer;

					&:hover {
						background-color: #4191E6;
						color: #FFF;
						border-color: transparent;
					}
				}
			}
		}
	}
</style>
